module.exports = __webpack_public_path__ + "static/media/ef_promoNav.243a03c3.svg";